import { SearchableDropdown } from 'commons/components';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { owcTheme } from 'core/theme/theme.config';
import styled, { css } from 'styled-components';

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const FormSectionTitle = styled(PocTypography)`
    font-weight: 600;
`;

export const FullWidthSearchableDropdown = styled(SearchableDropdown)`
    owc-select-dropdown {
        width: 100%;
    }
`;

const singleLineAssistiveText = css`
    /* OWC-OVERRIDE (@one 7.6.0): owc-input clips [slot='assistive-text']; keep field errors on one line, right-aligned. */
    && owc-input .owc-input__information-container > [slot='assistive-text'] {
        flex-wrap: nowrap;
        align-items: flex-end;
        min-width: 0;
        overflow: visible;
        white-space: nowrap;
    }

    owc-assistive-text {
        width: max-content;
        max-width: 100cqw;
        text-align: right;
        white-space: normal;
    }
`;

export const CompactInputWrapper = styled.div`
    flex-shrink: 0;
    width: 130px;

    ${singleLineAssistiveText}
`;

export const MonitoringPeriodRow = styled.div`
    container-type: inline-size;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const ThresholdRow = styled.div`
    container-type: inline-size;
    display: grid;
    grid-template-columns: auto auto 1fr 130px;
    gap: 8px;
    align-items: center;

    ${singleLineAssistiveText}
`;

export const OptionalRow = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 80px;
    align-items: center;
`;

export const OptionalSettingsOption = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.225rem;
`;

export const OptionalHint = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const FormSectionHint = styled(PocTypography)`
    margin-top: -16px;
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const FormSubmitSpinner = styled(PocProgressSpinner)`
    display: block;
`;
